import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	closeAndReturn: {
		id: 'project-create-importer-upload-flow.common.close-and-return-button.close-and-return',
		defaultMessage: 'Close and return to import from apps',
		description: 'Button text to close and return to import from apps step',
	},
});
